export const customJsonstringify = str => {
    if (str === undefined || str === null) {
        return 'null';
    }
    
    try {
        const jsonString = JSON.stringify(str);
        if (jsonString === undefined) {
            return 'null';
        }
        
        return jsonString.replace(/([&"'<>])/g, (char) => {
            switch (char) {
            case '&':
                return '\u0026'
            case '<':
                return '\u003c'
            case '>': 
                return '\u003e'
            case '"':
                return '\u0022'
            case "'":
                return "\u0027"
            default:
                return char
            }
        });
    } catch (error) {
        console.error('Error in customJsonstringify:', error);
        return 'null';
    }
}